module.exports = __webpack_public_path__ + "img/login_demo_pc.66aa4179.png";